import React, { useState, useEffect } from "react";
import { Row, Col, Card, CardBody, CustomInput, FormGroup } from "reactstrap";
import { Formik, Form, Field } from "formik";
import { toast } from "react-toastify";
import axios from "axios";
import { paths } from "../../../../../common/constants";
const PushNotification = () => {
  const [initFormikValue, setInitFormikValue] = useState({
    title: "",
    description: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const onSubmit = async (
    values,
    { setSubmitting, setErrors, setStatus, resetForm }
  ) => {
    setSubmitting(true);
    try {
      const headers = {
        "Content-Type": "application/json",
      };

      await axios.post(paths.api.v2.ADMIN_PUSH_NOTIFICATION, values, {
        headers: headers,
      });

      toast.success("Push successfully");
      setSubmitting(false);
      resetForm({});
    } catch (e) {
      console.log(e);
    }
  };
  return (
    <React.Fragment>
      {!isLoading && (
        <Formik
          enableReinitialize
          initialValues={initFormikValue}
          validate={(values) => {
            let errors = {};
            if (values.title === "") {
              errors.title = "Required";
            }
            if (values.description === "") {
              errors.description = "Required";
            }
            return errors;
          }}
          onSubmit={onSubmit}
          validateOnBlur={false}
        >
          {({
            errors,
            touched,
            setFieldTouched,
            isSubmitting,
            setFieldValue,
            values,
            setErrors,
            handleSubmit,
          }) => (
            <Form>
              <Row>
                <Col lg="12" xl="12">
                  <Card>
                    <div className={`py-3 px-4 card-header-top`}>
                      <h4
                        style={{ fontSize: 18, fontWeight: "bold" }}
                        className={`mb-0`}
                      >
                        Push Notification
                      </h4>
                    </div>
                    <CardBody>
                      <div>
                        <div className={`mb-3`}>
                          <FormGroup className="error-l-75">
                            <label className={`mb-2`} style={{ minHeight: 10 }}>
                              Title
                            </label>
                            <Field
                              disabled={values.disabled}
                              name={`title`}
                              className={`form-control`}
                            />
                            {errors.title && touched.title && (
                              <div className="invalid-feedback d-block">
                                {errors.title}
                              </div>
                            )}
                          </FormGroup>
                        </div>
                        <div className={`mb-3`}>
                          <FormGroup className="error-l-75">
                            <label className={`mb-2`} style={{ minHeight: 10 }}>
                              Text
                            </label>
                            <Field
                              disabled={values.disabled}
                              as={`textarea`}
                              name={`description`}
                              className={`form-control`}
                            />
                            {errors.description && touched.description && (
                              <div className="invalid-feedback d-block">
                                {errors.description}
                              </div>
                            )}
                          </FormGroup>
                        </div>
                      </div>
                      <div className={`mb-5`}>
                        <label>Preview</label>
                        <div className={`d-flex justify-content-center`}>
                          <Card
                            style={{
                              width: 450,
                              border: "1px solid rgba(0, 0, 0, 0.125)",
                            }}
                          >
                            <CardBody className={`py-3`}>
                              <div
                                className={`font-weight-bold pb-3 d-flex align-items-center`}
                              >
                                <img
                                  src={`http://dev.iloveshareapp.com/images/favicon.ico`}
                                  className={`mb-1`}
                                  width={30}
                                />{" "}
                                <span
                                  className={`ml-1`}
                                  style={{ color: "#d84eff" }}
                                >
                                  SHARE APP
                                </span>
                              </div>
                              <div>
                                <span className={`notify-mobile-demo-title`}>
                                  {values.title}
                                </span>
                              </div>
                              <div>
                                <span
                                  className={`notify-mobile-demo-description`}
                                >
                                  {values.description}
                                </span>
                              </div>
                            </CardBody>
                          </Card>
                        </div>
                      </div>
                      {!values.disabled && (
                        <React.Fragment>
                          <div className={`float-right`}>
                            <button
                              type={`submit`}
                              className={`btn btn-primary mr-2`}
                            >
                              {isSubmitting ? "Pushing..." : "Push"}
                            </button>
                          </div>
                        </React.Fragment>
                      )}
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      )}
    </React.Fragment>
  );
};

export default PushNotification;



// WEBPACK FOOTER //
// ./client/react/Admin/views/PushNotification/index.js